// extracted by mini-css-extract-plugin
export var logo = "_ls-2";
export var logoWrapper = "_ls-1";
export var strip = "_ls-0";